import { render, staticRenderFns } from "./ListCargaAryztaView.vue?vue&type=template&id=638e39a4&"
import script from "./ListCargaAryztaView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaAryztaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports